import React, { useLayoutEffect, useRef } from 'react'

const NumberComponent = React.memo(
  ({ focus, active, rowData, setRowData }) => {
    const ref = useRef(null)

    // This is the same trick as in `textColumn`
    useLayoutEffect(() => {
      if (focus) {
        ref.current?.focus()
      } else {
        ref.current?.blur()
      }
    }, [focus])

    return (
      <input
        className="w-full h-full border-none bg-transparent"
        type="text"
        inputMode='numeric'
        required
        // Important to prevent any undesired "tabbing"
        tabIndex={-1}
        ref={ref}
        // The `pointerEvents` trick is the same than in `textColumn`
        // Only show the calendar symbol on non-empty cells, or when cell is active, otherwise set opacity to 0
        style={{
          pointerEvents: focus ? 'auto' : 'none',
          opacity: rowData || active ? undefined : 0,
        }}
        value={rowData ?? ""}
        step={1}
        min={0}
        onChange={(e) => {
            let num = Number(e.target.value);
            if(!num && num !== 0) {
                num = 0;
            }
            if(num && num < 0) {
                num = 0;
            }
            // alert(num)
            setRowData(num)
        }}
      />
    )
  }
)

NumberComponent.displayName = 'NumberComponent'

export const numberColumn = {
  component: NumberComponent,
  deleteValue: () => null,
  // We convert the date to a string for copying using toISOString
  copyValue: ({ rowData }) =>
    rowData,
  // Because the Date constructor works using iso format, we can use it to parse ISO string back to a Date object
  pasteValue: ({ value }) => {
    return value
  },
  minWidth: 170,
  isCellEmpty: ({ rowData }) => !rowData,
}